<div class="d__flex header just-s">
  <!-- <ion-title class="margin p0" *ngIf="!DBservice.ismobile">Products</ion-title> -->
  <h2 class="fnt-20  myAccount-titles" *ngIf="!DBservice.ismobile">Products</h2>
  <ion-button *ngIf="!DBservice.ismobile" fill="clear"  slot="end" class="headerButton" (click)="open_product('Add')">
    <span class="span"><ion-icon src="/assets/icons/add.svg"></ion-icon></span> New
  </ion-button>
</div>
<ion-segment *ngIf="categorylist.length !=0" [(ngModel)]="select_value" scrollable (ionChange)="onCategoryChange($event)">
  <ion-segment-button value="All">
    <ion-label>All</ion-label>
  </ion-segment-button>
  <ion-segment-button *ngFor="let c of categorylist; let index = index;" [id]="c.product_category_name+'s'" value="{{c.product_category_name}}">
    <ion-label>{{c.product_category_name}}</ion-label>
  </ion-segment-button>
</ion-segment>
<!-- <ion-fab vertical="bottom" horizontal="end" slot="fixed">
    <ion-fab-button (click)="open_product('Add')">
      <ion-icon name="add"></ion-icon>
    </ion-fab-button>
  </ion-fab> -->




<ion-list *ngIf="false">
  <!-- [ngClass]="{'activated': (activeitem == index),'deactivated': (activeitem != index)}"  -->
  <ion-item *ngFor="let m of menulist; let index = index;" (click)="edititem(m ,index)" class="pl0">
    <ion-avatar slot="start" *ngIf="!m.images[0]">
      <div class="g41">
        <p> {{m.item[0]}} </p>
      </div>
    </ion-avatar>
    <ion-thumbnail slot="start" *ngIf="m.images[0]">
      <img class="cover-image" src="{{DBservice.product_img(m.images[0].list_image)}}">
    </ion-thumbnail>
    <ion-icon name="chevron-forward-outline" slot="end"></ion-icon>
    <ion-label class="m0">
      <h6 class="headertexth6">{{m.item}}</h6>
      <p class="pfont" *ngIf="m.price">₹ {{m.price}}</p>
    </ion-label>
  </ion-item>
</ion-list>





<div class="Fields-6" *ngIf="!DBservice.ismobile">
  <div class="table__data d__flex table__header">
    <div class="txt-center">
      <ion-checkbox class="check__box" (click)="check_box = !check_box"></ion-checkbox>
      <!-- <ion-icon class="fnt-14" name="square-outline"></ion-icon> -->
    </div>
    <div>Product Image</div>
    <div>Product</div>
    <div class="">SKU</div>
    <div class="txt-right pr15">Price</div>
    <div class="txt-center">Stock Qty</div>
  </div>
  <div class="orderss_list" *ngIf="categorylist.length !=0">
    <div class="main-item mouse" *ngFor="let item of menulist; let index = index;">
      <div class="table__data align-c d__flex table__items">
        <div class="txt-center">
          <ion-checkbox [checked]="check_box" class="check__box box__icon"></ion-checkbox>
          <!-- <ion-icon class="box__icon" name="square-outline"></ion-icon> -->
        </div>
        <div class="Product__img" (click)="edititem(item ,index)">
          <img *ngIf="item.image" [src]="DBservice.product_img(item.image)">
          <img *ngIf="!item.image" [src]="DBservice.product_img(item.image)">
        </div>
        <div class="txt_capital" (click)="edititem(item ,index)">
          <p class="m0">{{item.item}}</p>
        </div>
        <div class="" (click)="edititem(item ,index)">{{item.sku}}</div>
        <div class="txt-right pr15" (click)="edititem(item ,index)"> {{item.price  |currency:DBservice.currency}}</div>
        <div class="txt-center" (click)="edititem(item ,index)">{{item.stock}}</div>
      </div>
    </div>
  </div>
  <div *ngIf="menulist.length == 0 && categorylist.length ==0">
    <ion-item *ngFor="let i of [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15]">
      <!-- <ion-thumbnail slot="start">
        <ion-skeleton-text animated></ion-skeleton-text>
      </ion-thumbnail> -->
      <ion-label>
        <h3 class="d__flex just-s">
          <ion-skeleton-text animated style="width: 20px; height: 16px"></ion-skeleton-text>
          <ion-skeleton-text animated style="width: 15%; height: 16px"></ion-skeleton-text>
          <ion-skeleton-text animated style="width: 15%; height: 16px"></ion-skeleton-text>
          <ion-skeleton-text animated style="width: 15%; height: 16px"></ion-skeleton-text>
          <ion-skeleton-text animated style="width: 15%; height: 16px"></ion-skeleton-text>
          <ion-skeleton-text animated style="width: 15%; height: 16px"></ion-skeleton-text>
          <ion-skeleton-text animated style="width: 10%; height: 16px"></ion-skeleton-text>
        </h3>
      </ion-label>
    </ion-item>
  </div>
</div>




<div class="Fields-2" *ngIf="DBservice.ismobile">
  <div class="table__data d__flex table__header">
    <div>Product</div>
    <div>Price</div>
  </div>
  <div class="orderss_list">
    <div class="main-item mouse" *ngFor="let item of menulist; let index = index;" (click)="edititem(item ,index)">
      <div class="table__data d__flex table__items">
        <div class="txt_capital">
          <p>{{item.item}}</p>
        </div>
        <div> {{item.price |currency:DBservice.currency}}</div>
      </div>
    </div>
  </div>
</div>


